import { useQuery } from "@tanstack/react-query";
import { IOrgKpisApi } from "@/api/org-kpis";
import { SERVICES_TYPES, useInjection } from "@/ioc";
import { KpiPeriod } from "@/models/org-kpis";

export const useOrgKpis = (organizationId: string, period: KpiPeriod, enabled = true) => {
  const orgKpisApi = useInjection<IOrgKpisApi>(SERVICES_TYPES.ORG_KPIS);

  return useQuery({
    queryKey: ["org-kpis", organizationId, period.from, period.to],
    queryFn: () => orgKpisApi.getKpis(organizationId, period),
    enabled: enabled && !!organizationId
  });
};
